var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownload = function SvgIconDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b8c3d1",
    d: "M10.8 9.963H6.044a.6.6 0 0 0-.418 1.03l5.955 5.792a.6.6 0 0 0 .837 0l5.956-5.791a.6.6 0 0 0-.418-1.03H13.2V3.6a1.2 1.2 0 0 0-2.4 0zM3.6 20.436c0-.642.521-1.163 1.164-1.163h14.473a1.164 1.164 0 0 1 0 2.327H4.763A1.164 1.164 0 0 1 3.6 20.436"
  })));
};
export default SvgIconDownload;